import { useState, useEffect, useCallback } from 'react'

const useUpdateCheck = () => {
    const [updateInfo, setUpdateInfo] = useState(null)
    const [error, setError] = useState(null)
    const [lastCheckTime, setLastCheckTime] = useState(null)
    const [isInitializing, setIsInitializing] = useState(true)

    // 检查更新函数（始终静默运行）
    const checkForUpdates = useCallback(async () => {
        try {
            const response = await fetch('/api/check-update', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            })

            const data = await response.json()

            if (response.ok) {
                setUpdateInfo(data)
                setLastCheckTime(new Date())
                setError(null)

                // 仅在有更新时记录日志
                if (data.hasUpdate) {
                    console.log(`🎯 发现新版本: ${data.currentVersion} → ${data.latestVersion}`)
                }
            } else {
                setError(data.error || '检查更新失败')
                console.warn('版本检查失败:', data.error)
            }
        } catch (err) {
            console.warn('版本检查失败:', err.message)
            setError(err.message || '网络连接失败')
        } finally {
            setIsInitializing(false)
        }
    }, [])

    // 自动检查更新
    useEffect(() => {
        // 延迟初始检查，避免影响首屏加载
        const initialTimer = setTimeout(() => {
            checkForUpdates()
        }, 5000) // 延长到5秒，确保应用完全加载

        // 设置定期检查（每小时检查一次）
        const interval = setInterval(() => {
            checkForUpdates()
        }, 60 * 60 * 1000) // 1小时检查一次

        return () => {
            clearTimeout(initialTimer)
            clearInterval(interval)
        }
    }, [checkForUpdates])

    return {
        updateInfo,
        error,
        lastCheckTime,
        isInitializing,
        hasUpdate: updateInfo?.hasUpdate || false,
        currentVersion: updateInfo?.currentVersion,
        latestVersion: updateInfo?.latestVersion,
        // 提供手动刷新功能（用于调试）
        refreshCheck: checkForUpdates,
    }
}

export default useUpdateCheck
